import React, { useContext } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider, LanguageContext } from './context/LanguageContext.js';
import Home from './pages/Home.js';
import AboutMe from './pages/AboutMe.js';
import Contact from './pages/Contact.js';
import Navbar from './components/Navbar.js';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import LoadingIndicator from './components/LoadingIndicator';
import AniPage  from './pages/Ani.js'
import Ani8MarchMemoryGame from './pages/Ani_8MarchMemoryGame';

// Wrapper component to access LanguageContext
const AppContent = () => {
  const { isLoading } = useContext(LanguageContext);
  const location = useLocation();
  const hideNavbar = location.pathname === "/ani" || location.pathname === "/ani-memory-game";
  
  return (
    <div>
      {isLoading && <LoadingIndicator />}
      {!hideNavbar && <Navbar/>}
      <Routes>
        <Route path="/" element={< Home />} />
        <Route path="/about" element={< AboutMe />} />
        <Route path="/contact" element={< Contact />} />
        <Route path="/privacy-policy" element={< PrivacyPolicy />} />
        <Route path="/terms-of-service" element={< TermsOfService />} />
        <Route path="/ani" element={< AniPage />} />
        <Route path="/ani-memory-game" element={< Ani8MarchMemoryGame />} />
      </Routes>
    </div>
  );
};

const App = () => {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
};

export default App;
